import React, { useContext } from "react";
import { observer } from "mobx-react-lite";
import { Divider, Radio, List, Container } from "semantic-ui-react";
import { RateStoreContext } from "../../stores/RateStore";
import { AppStoreContext } from "../../stores/AppStore";
import { GLOBAL_MODALS } from "../../stores/modals";
import { trackAction } from "../../tracking";
import OnboardingActions from "../../tracking/actions";
import { useTranslation } from "react-i18next";
// rate-recommender stops capping rate after 200K, after that, it doesnt do much w/ this info
// https://github.com/glg/rate-service/blob/5dd5703bce1603acc557f43a4df4a3a4ba0fb75e/src/model/rateRecommendation.js#L91-L95

const listContainerStyle = { display: "inline-block", width: "auto" };
const dividerStyle = { margin: "2rem 0" };
const pStyle = { marginBottom: "2rem" };

export default observer(function Salary() {
  const appStore = useContext(AppStoreContext);
  const rateStore = useContext(RateStoreContext);
  const [t] = useTranslation();
  const selectSalary = (e, { value }) => {
    trackAction(OnboardingActions.SelectSalary)
    rateStore.salary = value;
    rateStore.getRecommended()
      .catch(() => appStore.globalModal = GLOBAL_MODALS.FATAL_ERROR);
  };

  let options;
  if (appStore.zoneRegion === "Asia") {
    options = [
      { label: "< $25,000 USD", value: "25K" },
      { label: "$25,000 USD to < $50,000 USD", value: "25K-50K" },
      { label: "$50,000 USD to < $100,000 USD", value: "50K-100K" },
      { label: "$100,000 USD to $200,000 USD", value: "100K-200K" },
      { label: ">$200,000 USD to $300,000 USD", value: "200K-300K" },
      { label: ">$300,000 USD", value: "300K+" },
      { label: t("salary_modal_no_share"), value: "other" }
    ];
  } else {
    options = [
      { label: "< $100,000 USD", value: "50K-100K" },
      { label: "$100,000 USD - <$200,000 USD", value: "100K-200K" },
      { label: "$200,000 USD - <$350,000 USD", value: "200K-350K" },
      { label: "$350,000 USD - <$500,000 USD", value: "350K-500K" },
      { label: "$500,000+ USD", value: "500K+" },
      { label: t("salary_modal_no_share"), value: "other" }
    ];
  }

  return <div>
      <Divider horizontal style={dividerStyle}>
        {t("salary_modal_current_comp")}
      </Divider>
      <p style={pStyle}>{t("salary_modal_instructions")}</p>
      <Container textAlign="left" style={listContainerStyle}>
        <List>
          {options.map(o => <List.Item key={o.value}>
              <Radio label={o.label} value={o.value} onChange={selectSalary} checked={o.value === rateStore.salary} disabled={rateStore.isSaving} />
            </List.Item>)}
        </List>
      </Container>
    </div>;
});
